import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DigitalOrder as SchemaDigitalOrder } from '../schemas/DigitalOrder';
import { type MetaDigitalOrder as SchemaMetaDigitalOrder } from '../schemas/MetaDigitalOrder';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const UpdateDigitalOrderContentType = 'application/json' as const;
export type UpdateDigitalOrderRequest = SchemaMetaDigitalOrder;
export type UpdateDigitalOrderResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaDigitalOrder;
    };
};
export type UpdateDigitalOrderResponseSuccess = UpdateDigitalOrderResponses['200']['application/json'];
export type UpdateDigitalOrderSearchParams = {
    signature: string;
};
export type UpdateDigitalOrderPathParameters = {
    store_slug: string;
    order_id: string;
};
export const UpdateDigitalOrderUrl = '/{store_slug}/digital_orders/{order_id}' as const;
export const UpdateDigitalOrderMethod = 'PATCH' as const;
export const getUpdateDigitalOrderUrl = (params: UpdateDigitalOrderPathParameters) =>
    UpdateDigitalOrderUrl.replace(/\{(\w+)\}/g, (_match, param: keyof UpdateDigitalOrderPathParameters) =>
        String(params[param])
    );
